"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paper = exports.blockClass = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
exports.blockClass = (0, nano_theme_1.drule)({
    bdrad: '4px',
    trs: 'background .3s',
});
const hoverBlockClass = (0, nano_theme_1.drule)({});
const hoverElevateClass = (0, nano_theme_1.drule)({
    trs: 'box-shadow 0.5s',
});
const Paper = (props) => {
    const { level = 0, fill = 0, round, hover, hoverBg, hoverLite, hoverElevate, contrast, noOutline, ref, ...rest } = props;
    const styles = (0, context_1.useStyles)();
    const bg = styles.bg + '';
    const light = styles.light;
    const style = {};
    if (!hover) {
        style.border = `1px solid ${styles.g(0, contrast ? 0.2 : 0.1)}`;
    }
    if (level > 1) {
        style.border = `1px solid ${styles.g(0, 0.1 + 0.03 * level)}`;
    }
    if (noOutline) {
        style.border = 'none';
    }
    if (round) {
        style.borderRadius = '16px';
    }
    return React.createElement('div', {
        ...rest,
        ref,
        className: props.className +
            (0, exports.blockClass)({
                bg,
                'a &': {
                    col: styles.g(0.25),
                },
                bxsh: level
                    ? `0px 1px ${1 + level * 2}px 0px ${styles.g(0, 0.2)}, 0px ${level}px ${level}px 0px ${styles.g(0, 0.14)}, 0px ${1 + level}px 1px -${level}px ${styles.g(0, 0.12)}`
                    : 'none',
                ...(hoverBg
                    ? {
                        bg: fill ? styles.g(0, fill * 0.02) : bg,
                        '&:hover': {
                            bg: styles.g(0, 0.02),
                        },
                    }
                    : {}),
            }) +
            (hover
                ? hoverBlockClass({
                    bd: `1px solid ${styles.g(0, 0.1)}`,
                    '&:hover': {
                        bd: `1px solid ${styles.g(0, 0.2)}`,
                    },
                    '&:active': {
                        bd: `1px solid ${styles.g(0, 0.3)}`,
                    },
                })
                : '') +
            (hoverElevate
                ? hoverElevateClass({
                    '&:hover': {
                        bxsh: light
                            ? '0 3px 5px rgba(0,0,0,.1), 0 10px 20px rgba(0,0,0,.1)'
                            : '0 3px 5px rgba(0,0,0,.5), 0 10px 20px rgba(0,0,0,.5), 0 0 0 1px rgba(255,255,255,.06)',
                    },
                })
                : ''),
        style: { ...style, ...(props.style || {}) },
    });
};
exports.Paper = Paper;
exports.default = exports.Paper;
